
import React from "react";

import {
    View,
    Text,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    Image,
} from "react-native";

import {RFValue} from "react-native-responsive-fontsize";
import {Ionicons, FontAwesome} from "@expo/vector-icons";
import Config from "../../Config";
import StartPlacement from "./StartPlacement";


const Placement = ({navigation}) => {

    return (
        <View style={styles.container}>

            <View style={styles.header}>
                <TouchableOpacity style={{flex: 1}}>
                    <Text style={styles.title}>
                        آزمون تعیین سطح
                    </Text>
                </TouchableOpacity>

                <TouchableOpacity onPress={() => navigation.goBack()}>
                    <Ionicons
                        style={styles.selficon}
                        name="arrow-back"
                        size={24}
                        color="white"
                    />
                </TouchableOpacity>
            </View>

            <ScrollView
                style={{
                    flex: 1,
                    backgroundColor: Config.maincolor
                }}
            >
                <View style={styles.content}>

                    <View style={styles.imageContainer}>
                        <Image
                            style={styles.image}
                            source={require('../../assets/images/about.png')}
                        />
                    </View>

                    <Text style={styles.h2}>
                        آزمون تعیین سطح زبان انگلیسی
                    </Text>

                    <Text style={styles.p}>
                        با انجام این آزمون، سطح فعلی زبان انگلیسی شما را ارزیابی می‌کنیم
                        تا بتوانید یادگیری خود را از مناسب‌ترین سطح شروع کنید.
                    </Text>

                    <Text style={styles.p}>
                         سؤالات از سطح مقدماتی تا پیشرفته
                        طراحی شده‌اند. در پایان آزمون، سطح زبان انگلیسی شما از
                        <Text style={styles.li}> A1 تا C2 </Text>
                        مشخص خواهد شد.
                    </Text>

                    <Text style={styles.h2}>
                        قبل از شروع
                    </Text>

                    <View style={styles.ul}>
                        <FontAwesome
                            name="check"
                            size={RFValue(14)}
                            style={styles.check}
                            color="#FFF"
                        />

                        <Text style={styles.p}>
                            سعی کنید به سؤالات بدون استفاده از مترجم یا منابع دیگر پاسخ دهید.
                        </Text>
                    </View>

                    <View style={styles.ul}>
                        <FontAwesome
                            name="check"
                            size={RFValue(14)}
                            style={styles.check}
                            color="#FFF"
                        />

                        <Text style={styles.p}>
                            اگر پاسخ سؤالی را نمی‌دانید، بهتر است آن را بدون پاسخ بگذارید.
                        </Text>
                    </View>

                    <View style={styles.ul}>
                        <FontAwesome
                            name="check"
                            size={RFValue(14)}
                            style={styles.check}
                            color="#FFF"
                        />

                        <Text style={styles.p}>
                            برای هر پاسخ صحیح امتیاز دریافت می‌کنید و پاسخ‌های اشتباه
                            دارای نمره منفی هستند.
                        </Text>
                    </View>

                    <View style={styles.ul}>
                        <FontAwesome
                            name="check"
                            size={RFValue(14)}
                            style={styles.check}
                            color="#FFF"
                        />

                        <Text style={styles.p}>
                            هدف این آزمون قبولی یا رد شدن نیست؛ فقط می‌خواهیم سطح فعلی
                            شما را بهتر بشناسیم.
                        </Text>
                    </View>

                    <View style={styles.notice}>
                        <Text style={styles.noticeText}>
                            برای اینکه نتیجه آزمون دقیق‌تر باشد، لطفاً پاسخ‌ها را
                            بر اساس دانش واقعی خودتان انتخاب کنید.
                        </Text>
                    </View>

                    <TouchableOpacity
                        style={styles.startButton}
                        onPress={() => navigation.navigate("StartPlacement")}
                    >
                        <Text style={styles.startButtonText}>
                            بریم برای تعیین سطح
                        </Text>

                        <Ionicons
                            name="arrow-back"
                            size={RFValue(20)}
                            color="#FFF"
                        />
                    </TouchableOpacity>

                </View>
            </ScrollView>

        </View>
    );
};


const styles = StyleSheet.create({

    container: {
        flex: 1,
        backgroundColor: Config.maincolor,
    },

    header: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        backgroundColor: "#000422",
        paddingHorizontal: RFValue(20),

        shadowColor: "#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1,
    },

    title: {
        fontSize: RFValue(17),
        fontFamily: "ykb",
        color: "#FFF",
        paddingVertical: RFValue(14),
    },

    content: {
        flex: 1,
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(20),
        backgroundColor: Config.maincolor,
    },

    imageContainer: {
        justifyContent: "center",
        alignItems: "center",
    },

    image: {
        width: RFValue(190),
        height: RFValue(170),
        marginBottom: RFValue(20),
    },

    h2: {
        fontFamily: "ykb",
        fontSize: RFValue(18),
        marginVertical: RFValue(10),
        color: "#FFF",
    },

    p: {
        flex: 1,
        fontFamily: "ykb",
        fontSize: RFValue(12),
        lineHeight: RFValue(22),
        marginVertical: RFValue(6),
        color: "#E4E4E4",
        textAlign: "justify",
    },

    li: {
        fontFamily: "ykb",
        fontSize: RFValue(12),
        color: "#FFF",
    },

    ul: {
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: RFValue(8),
    },

    check: {
        backgroundColor: "#33B300",
        padding: RFValue(2),
        borderRadius: RFValue(100),
        marginTop: RFValue(10),
    },

    notice: {
        backgroundColor: "#000422",
        borderRadius: RFValue(8),
        paddingHorizontal: RFValue(14),
        paddingVertical: RFValue(10),
        marginTop: RFValue(15),
        marginBottom: RFValue(20),
    },

    noticeText: {
        fontFamily: "ykb",
        fontSize: RFValue(11),
        lineHeight: RFValue(21),
        color: "#E4E4E4",
        textAlign: "center",
    },

    startButton: {
        backgroundColor: Config.secondcolor,
        borderRadius: RFValue(8),
        paddingVertical: RFValue(13),
        paddingHorizontal: RFValue(18),
        marginTop: RFValue(5),
        marginBottom: RFValue(20),

        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: RFValue(10),

        elevation: 3,
    },

    startButtonText: {
        fontFamily: "ykb",
        fontSize: RFValue(14),
        color: "#FFF",
    },

});


export default Placement;

